const AnalyticsEventNames = {
  addToCart: 'addToCart',
  analytics: 'analytics',
  cartStatus: 'cartStatus',
  checkout: 'checkout',
  checkoutOption: 'checkoutOption',
  clearCart: 'clearCart',
  pageNotFound: 'pageNotFound',
  productClick: 'productClick',
  productDetail: 'productDetail',
  productImpressions: 'productImpressions',
  promotionClick: 'promotionClick',
  promoView: 'promoView',
  purchase: 'purchase',
  quickSearch: 'quickSearch',
  refund: 'refund',
  removeFromCart: 'removeFromCart',
  reserveAndCollect: 'reserveAndCollect',
  setPage: 'setPage',
  suggestionSelection: 'suggestionSelection',
  updateDimension: 'updateDimension'
};

export default AnalyticsEventNames;



// WEBPACK FOOTER //
// ./src/analytics/AnalyticsEventNames.js